import React from 'react';
import Dash from '../components/Dashboard';

export default function DashboardPage() {
  return <Dash />;
}
